import { useMemo } from 'react';

import { isMatching } from 'utility/Check/isMatching';

import { useFilterTerm } from '../__context/filterTerm';
import { GroupHeadlineProps } from '../__partials/GroupHeadline';
import { FilterElement } from '../types';

interface UseFilterProps {
    filterList: FilterElement[];
    headline?: GroupHeadlineProps;
}

export const useFilter = ({
    filterList,
    headline,
}: UseFilterProps): FilterElement[] => {
    const filterTerm = useFilterTerm();

    const headLineText = headline?.text;

    return useMemo(() => {
        const nonEmptyFilterList = filterList.filter(
            (section) => section.content
        );

        if (!filterTerm) {
            // no filter term -> return complete list

            return nonEmptyFilterList;
        }
        if (headLineText && isMatching(headLineText, filterTerm)) {
            // headline matches -> return complete list
            return nonEmptyFilterList;
        }
        // return filtered list
        return nonEmptyFilterList.filter((filterElement) =>
            isMatching(filterElement.filterValue, filterTerm)
        );
    }, [filterList, filterTerm, headLineText]);
};
